<template>
  <body ref="bodyBg">
    <div v-if="!usingMobile && showEnlargedImage">
      <div
        class="enlarged-image-bg"
        @click="clearEnlargedImage"
      />
      <p
        class="close-enlarged-image"
        @click="clearEnlargedImage"
      >
        X
      </p>
      <img
        class="enlarged-image"
        :src="require(`@/assets/images/software_projects/img_inverter/${imgIdx}.png`)"
      >  
    </div>
    <div
      style="width:90%; background-color: black; margin-left: 5%; margin-top: .5rem; "
    >
      <h1
        class="
    welcome"
      >
        mNcClOuD
      </h1>
      <div
        class="container"
      >
        <div class="row">
          <div class="mx-auto">
            <div class="fragment-container">
              <h2
                :class="fragments[0] ? 'btnSelected': ''"
                @click="toggleFragment(0)"
              >
                about
              </h2>
              <h2
                :class="fragments[1] ? 'btnSelected': ''"
                @click="toggleFragment(1)"
              >
                video art
              </h2>
              <h2
                :class="fragments[2] ? 'btnSelected': ''"
                @click="toggleFragment(2)"
              >
                game projects
              </h2>
            </div>
            <div class="row fragment-container second-row">
              <h2
                :class="fragments[5] ? 'btnSelected': ''"
                @click="toggleFragment(5)"
              >
                image inverter
              </h2>
              <h2
                :class="fragments[3] ? 'btnSelected': ''"
                @click="toggleFragment(3)"
              >
                contact
              </h2>
            </div>
          </div>
        </div>
        <about
          v-show="fragments[0]"
          :mobile="usingMobile"
        />
        <videos
          v-show="fragments[1]"
        />
        <games 
          v-if="fragments[2]"
          class="games-fragment" 
          @closeGamesPage="toggleFragment(2)"
        />
        <contact v-show="fragments[3]" />
        <taiyo
          v-show="fragments[4]"
          @closeTaiyo="toggleFragment(4)"
        />
        <software
          v-show="fragments[5]"
          class="software-fragment"
          :mobile="usingMobile"
          :img-enlarged="showEnlargedImage"
          @enlargeImage="enlargeImage"
          @changeImgIdx="setImgIdx"
        />
        <div
          class="mx-auto taiyo-img"
        >
          <img
            id="taiyo-img"
            :src="require(`@/assets/${taiyosLocation}`)"
            @mouseover="taiyosLocation='gifs/taiyos4.gif'"
            @mouseleave="taiyosLocation='gifs/tasiyosresized/tq.png'"
            @click="toggleFragment(4)"
          >
        </div>
      </div>
      <h5 id="trademark">
        {{ trademarkName }} McCloud 2026
      </h5>
    </div>
  </body>
</template>

<script setup>
import { animateBg } from '../utils/radialZoom.js';
import { messages } from '../data/banner_msgs.js';
import { onMounted, onUnmounted, ref, computed } from 'vue';
import About from "./About.vue";
import Videos from "./Videos.vue";
import Games from "./Games.vue";
import Contact from "./Contact.vue";
import Taiyo from "./Taiyo.vue";
import Software from './Software.vue';
import { detectMobile } from '../utils/detectMobile.js';
const taiyosLocation = ref('gifs/tasiyosresized/tq.png');
const messageIndex = ref(0);
const bodyBg = ref(null);
const trademarkName = ref("Nathan");
const imgIdx = ref(0);
const showEnlargedImage = ref(false);
const usingMobile = ref(false);

const fragments = ref([false, false, false, false, false, false]);

const toggleFragment = (fragmentIdx) => {
  if(!fragments.value[fragmentIdx]) 
    fragments.value = fragments.value.map((_, i) => i === fragmentIdx);
  else fragments.value[fragmentIdx] = false;
  trademarkName.value = (fragments.value[4])  ? "Taiyo" : "Nathan";
}

onMounted(() => {
  messageIndex.value = Math.floor(Math.random() * messages.length);
  animateBg(bodyBg.value);
  usingMobile.value = detectMobile();
})

onUnmounted(() => {
  animateBg(null, true);
})

const enlargeImage = (val) => {
  imgIdx.value = val;
  showEnlargedImage.value = true;
}

const clearEnlargedImage = () => {
  if(showEnlargedImage.value) showEnlargedImage.value = false;
}

const setImgIdx = (val) => {
  imgIdx.value = val;
}

</script>

<style lang="scss">
.btnSelected {
  opacity: .6;
}
</style>

<style lang="scss" scoped>

$sm: 540px;
$md: 720px;
$lg: 960px;
$xl: 1140px;

.enlarged-image {
  max-height: 100vh;
  position: fixed;
  top: 0px;
  left: 50%;
  right: 0;
  transform: translateX(-50%);
  z-index: 101;
}



body {
  @include noselect;
  border-style: solid;
  border-spacing: 1em;
  background-color: black;
  border-color: black;
  text-align: center;
  min-height: 100vh;
  color: white;
}

h1 {
  text-align: center;
}

h3 {
  text-align: center;
  @include rainbow-gradient;
  @include text-outline;
}

h3 {
  font-size: 1.5rem;
  @media screen and (max-width: $md) {
    font-size: inherit;
  }
}

h2 {
  font-size: 2.5rem;
}

h5 {
  text-align: center;
  font-size: 1rem;
}

.welcome {
  @include colorful-radial-gradient-alt;
  border: 1px solid white;
  width: max-content;
  margin: auto;
  margin-bottom: 1rem;
  font-family: Blox2;
  color: black;
  grid-column: 1;
  grid-row: 1;
  font-size: 3rem;
  text-shadow:
    1px 1px 0 white,
    -1px 1px 0 white,
    -1px -1px 0 white,
    1px -1px 0 white;
  @media (min-width: $xl) {
    margin-top: 1rem;
  }
}

.break {
  height: .5em;
  width: 70%;
  @include rainbow-gradient;
  @include hr-outline;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

#taiyo-img {
  position: absolute;
  bottom: 20px;
  left: 20px;
  width: 3%;
  border-color:gray;
  border-style: solid;
  border-width: 1px;
  margin-top: 2rem;
  @media(max-width: $lg) {
    width: 10%;
  }
}

#taiyo-img:hover {
  border-color: white;
  cursor: pointer;
}

#enter {
  margin-top: 1.25rem;
  @include text-outline(3px);
}

#trademark {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  font-family: 'Russo One', sans-serif;
}

.fragment-container {
  display: flex;
 @media(max-width: $md) {
  flex-direction: column;
 } 
 @media(min-width: $md) {
  gap: 1rem;
 } 
  font-family: Typo-Rounded;
}

.fragment-container h2 {
  cursor: pointer;
  @media(max-width: $md){
    line-height: 25px;
    font-size: 2rem;
  }
}

.fragment-container h2:hover {
  filter: brightness(60%);
}

.second-row {
  justify-content: center;
}

.enlarged-image-bg {
  background-color: black;
  position: fixed;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  opacity: 1;
  top: 0;
  left: 0;
}

.close-enlarged-image {
  position: fixed;
  z-index: 101;
  right: 10px;
  top: 5px
}

.close-enlarged-image:hover {
  opacity: 50%;
  cursor: pointer;
}

</style>
